export default __webpack_public_path__ + "static/media/APACHE RTR 180 2V_5.85d07616.webp";